// extracted by mini-css-extract-plugin
export default {"languageLink":"Language__languageLink--1JH","icon":"Language__icon--2Sd","language":"Language__language--KNQ"};